//Page validation
import validatePersonalInfo from "./../personal-information/validate";
import validateEmploymentDesired from "./../employment-desired/validate";
import validateEducation from "./../education/validate";
import validateEmploymentHistory from "./../employment-history/validate";

const validationPages = [
  {
    validate: validatePersonalInfo,
    label: "Personal Information",
    url: "#/personal-information"
  },
  {
    validate: validateEmploymentDesired,
    label: "Employment Desired/Availability",
    url: "#/employment-desired"
  },
  {
    validate: validateEducation,
    label: "Education",
    url: "#/education"
  },
  {
    validate: validateEmploymentHistory,
    label: "Employment History",
    url: "#/employment-history"
  }
];

function isEmpty(value){
  return (value == null || value.length === 0 || value == undefined);
}


const validate = values => {
  let errors = {
    pages:[]
  };
  //validate this form
  const requiredFields = ["electronicSignature", "recaptcha"];
  requiredFields.forEach(function(field){
    if(isEmpty(values[field])){
      errors[field] = 'Required';
    }
  });

  //validate ALL pages
  validationPages.forEach(page => {
    let pageErrors = page.validate(values);
    console.log(Object.keys(pageErrors).length);
    console.log(pageErrors);
    if(Object.keys(pageErrors).length){
      errors.pages.push({
        label: page.label,
        url: page.url
      });
    }
  });

  return errors
}

export default validate
